(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["diamond-engraving-upload"] && !Shopify.designMode) return;
  try {
    function validateDiamondReference(input) {
    const file = input.files[0];
    const valid = !file || (['image/jpeg', 'image/png', 'image/webp'].includes(file.type) && file.size <= 10 * 1024 * 1024);
    input.setCustomValidity(valid ? '' : input.dataset.errorMessage);
    return valid;
  }
  document.addEventListener('change', function(event) {
    if (event.target.matches('[data-diamond-engraving-file]')) {
      const status = event.target.closest('.diamond-engraving-picker').querySelector('[data-diamond-filename]');
      status.textContent = event.target.files[0] ? event.target.files[0].name : 'No image selected';
      validateDiamondReference(event.target);
      event.target.reportValidity();
    }
  });
  document.addEventListener('submit', function(event) {
    if (!(event.target instanceof HTMLFormElement)) return;
    const input = event.target.querySelector('[data-diamond-engraving-file]');
    if (!input || !input.files.length) return;
    event.stopImmediatePropagation();
    if (!validateDiamondReference(input)) {
      event.preventDefault();
      input.reportValidity();
      return;
    }
    event.target.enctype = 'multipart/form-data';
  }, true);
  } catch(e) { console.error(e); }
})();

})();
